// you created this to display overlays checkboxes

import React from "react";

export const CheckBoxSnow = (props) => {
 
    return (
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id={props.id}
          key={props.id}
          onClick={props.handleCheckChieldElement}
          checked={props.isChecked}
          value={props.value}
         
        />
        <label class="custom-control-label" for={props.id}>
          {props.value}
        </label>
      </div>
    );
  };
  

export default CheckBoxSnow;



